export function formatCurrency(n: number): string {
	return `$${Number(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
}

const CCY_SYMBOL: Record<string, string> = {
	USD: '$',
	GBP: '£',
	EUR: '€',
	INR: '₹',
}

export function getCurrencySymbol(ccy: string): string {
	return CCY_SYMBOL[ccy?.toUpperCase()] || '$'
}
